module.exports = __webpack_public_path__ + "static/media/app-bar-save.ff1995bf.svg";